
<div class="apg-panel">
  <div class="apg-loading" *ngIf="loading">
    <p>{{message}}</p>
    <ion-spinner></ion-spinner>
  </div>

  <ng-container [ngSwitch]="mode" *ngIf="!loading">

    <app-bank-details-content *ngSwitchCase="'intro'" key="BankDetails.DirectDebitIntro" (continue)="mode = 'questions'"
      (back)="back.emit($event)">
    </app-bank-details-content>

    <ng-container *ngSwitchCase="'questions'">

      <app-bank-details-question-page name="BankDetails" [error]="error" [key]="key" [answers]="answers"
        (back)="mode = 'intro'" (continue)="mode = 'confirm'">
      </app-bank-details-question-page>

    </ng-container>

    <app-bank-details-content *ngSwitchCase="'contact-complete'" key="FullQuote.RequestContactConfirmation"
      [buttons]="[]" [showTitle]="false">
    </app-bank-details-content>

    <app-bank-details-confirm *ngSwitchCase="'confirm'" [answers]="answers" [key]="key" (back)="mode = 'amend'"
      (continue)="detailsConfirmed($event)">
    </app-bank-details-confirm>

    <ng-container *ngSwitchCase="'amend'">

      <app-bank-details-question-page name="BankDetails.Amend" [error]="error" [key]="key" [answers]="answers"
        (back)="mode = 'intro'" (continue)="amendDetails()">
      </app-bank-details-question-page>

    </ng-container>

    <ng-container *ngSwitchCase="'contact-request'">

      <app-bank-details-question-page name="BankDetails.ContactRequest" [error]="error" [key]="key" [answers]="answers"
        (back)="mode = 'amend'" (continue)="saveContactRequest()">
      </app-bank-details-question-page>

    </ng-container>

    <app-site-content *ngSwitchCase="'error'" key="FullQuote.Error" [showTitle]="false">
    </app-site-content>

  </ng-container>

</div>